import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';

export function useWorkorderItemPermissions() {
  return {
    editDiscountValue: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_ITEM_EDIT_DISCOUNT_VALUE,
    ]),
    addDiscountGreaterDefinedByCompany: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_ADD_DISCOUNT_PERCENTAGE_GREATER_THAN_DEFINED_BY_THE_COMPANY,
    ]),
    giveDiscountOverLimit: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_GIVE_DISCOUNT_OVER_LIMIT,
    ]),
    openedItemChangeDiscount: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_DISCOUNT,
    ]),
    giveDiscountOutsourcedServices: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_GIVE_DISCOUNT_OUTSOURCED_SERVICES,
    ]),
    makeSaleAboveCreditLimit: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_MAKE_SALE_ABOVE_CREDIT_LIMIT,
    ]),
    allowSellingBellowCostValue: hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_ALLOW_SELLING_BELOW_COST_VALUE,
    ]),
  };
}
